/**
 * 日付・時刻のフォーマット
 * 内部はUTC文字列。表示はJST。
 */
function toDate(s: string): Date {
  // 'YYYY-MM-DD HH:MM:SS' (UTC) を ISO-Z にして new Date
  const iso = s.replace(' ', 'T') + 'Z';
  return new Date(iso);
}

export function formatTime(s: string | null): string {
  if (!s) return '';
  const d = toDate(s);
  const now = new Date();
  const sameDay =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday =
    d.getFullYear() === yesterday.getFullYear() &&
    d.getMonth() === yesterday.getMonth() &&
    d.getDate() === yesterday.getDate();

  if (sameDay) {
    return d.toLocaleTimeString('ja-JP', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  }
  if (isYesterday) return '昨日';
  if (d.getFullYear() === now.getFullYear()) {
    return d.toLocaleDateString('ja-JP', { month: 'numeric', day: 'numeric' });
  }
  return d.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
}

export function formatDateTime(s: string | null): string {
  if (!s) return '';
  const d = toDate(s);
  return d.toLocaleString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function formatDate(s: string | null): string {
  if (!s) return '';
  const d = toDate(s);
  return d.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

export function formatHHMM(s: string | null): string {
  if (!s) return '';
  const d = toDate(s);
  return d.toLocaleTimeString('ja-JP', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/**
 * メッセージリストの日付区切りを判定するためのキー
 */
export function dateKey(s: string): string {
  const d = toDate(s);
  return d.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
}

/**
 * 名前のイニシャル（アバター用）
 */
export function initial(name: string): string {
  if (!name) return '?';
  return name.charAt(0).toUpperCase();
}
